import { useFormattedOfferedMaxTerms } from "@faire/retailer-visitor-shared/hooks/openWithFaire/useFormattedOfferedMaxTerms";
import { isRetailerOnNetTerms } from "@faire/retailer-visitor-shared/hooks/retailer/isRetailerOnNetTerms";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingSkipOwFUpsell } from "@faire/retailer-visitor-shared/settings/useSettingSkipOwFUpsell";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const Header: React.FC = () => {
  const hasSkippedOwFUpsell = useSettingSkipOwFUpsell();
  const formattedOfferedMaxTerms = useFormattedOfferedMaxTerms();
  const { retailer } = useRetailer();
  const isRetailerQualifiedForNetTerms = isRetailerOnNetTerms(retailer);
  return (
    <>
      {hasSkippedOwFUpsell ? null : (
        <>
          <TagLine variant="paragraphSansMedium">
            <StrictLocalMsg
              defaultMessage="Open with Faire"
              description={{
                text: "Name of a program that Faire offers to new retailers",
              }}
            />
          </TagLine>
          <Spacer height="2x" />
        </>
      )}
      <Title variant="displaySSerifRegular">
        {!isRetailerQualifiedForNetTerms && hasSkippedOwFUpsell ? (
          <StrictLocalMsg
            defaultMessage="You’re eligible for up to {offeredMaxTermsMoney} in payment terms!"
            description={{
              text: "Title of an application form",
              img: "https://cdn.faire.com/fastly/1cd3c1870c1c80c95b40e9beb64f06ed9c246b8f52df63716400cb72fb52f5c4.png",
            }}
            values={{
              offeredMaxTermsMoney: formattedOfferedMaxTerms,
            }}
          />
        ) : (
          <StrictLocalMsg
            defaultMessage="Tell us about your new business"
            description={{ text: "Title of an application form" }}
          />
        )}
      </Title>
      <Spacer height="2x" />
      <Description>
        {!isRetailerQualifiedForNetTerms && hasSkippedOwFUpsell ? (
          <StrictLocalMsg
            defaultMessage="This means you can buy inventory today and pay up to 60 days later—interest-free. We use this info to determine your terms amount."
            description={{
              text: "Describing what is this application used for",
              img: "https://cdn.faire.com/fastly/1cd3c1870c1c80c95b40e9beb64f06ed9c246b8f52df63716400cb72fb52f5c4.png",
            }}
          />
        ) : (
          <StrictLocalMsg
            defaultMessage="We'll use this info to determine your new 60-day payment terms on Faire."
            description={{
              text: "Describing what is this application used for",
            }}
          />
        )}
      </Description>
    </>
  );
};

const Description = styled(Typography)`
  &&& {
    max-width: 350px;
  }
`;

const TagLine = styled(Typography)`
  &&& {
    letter-spacing: 1px;
  }
`;

const Title = styled(Typography)`
  &&& {
    max-width: 433px;
  }
`;
